import VueGtag from 'vue-gtag';
import router from '../router';

import { pageview, screenview } from 'vue-gtag';

const enableGtag = process.env.NODE_ENV === 'production' || true;

export const vueGtagPlugin = {
    install(Vue) {
        VueGtag(
            Vue,
            {
                appName: `Tryhala (${process.env.NODE_ENV})`,
                config: {
                    id:
                        process.env.NODE_ENV === 'production'
                            ? 'G-1N4C6263ZP'
                            : undefined,
                    send_page_view: true
                },
                pageTrackerEnabled: false,
                bootstrap: !!enableGtag,
                enabled: !!enableGtag,
                disableScriptLoad: !enableGtag
            },
            router
        );
        apiWrapper(Vue);
    }
};

function apiWrapper(Vue) {
    const apiList = [pageview, screenview];

    apiList.forEach(f => {
        const name = f.name;
        Vue.$gtag[name] = Vue.prototype.$gtag[name] = (...args) => {
            if (enableGtag) f(args);
        };
    });
}
